import React from 'react';
import { faChevronRight, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  useGetAvailableSchoolYearsMutation,
  useGetAllStatesMutation,
  useGenerateOneTimeCodeMutation,
  useGetAllSchoolsMutation,
  useUpdateAdditonalOptionsCommentMutation,
  useUpdateSchoolYearMutation,
  useUpdateStateMutation,
  useGetschoolInfoMutation
} from '../../../features/authentication/authApiSlice';
import { useGetCRMUrlMutation } from '../../../features/authentication/dashboardHeaderApiSlice';
import { Row, Tooltip, OverlayTrigger } from 'react-bootstrap';
import Modal from '../../../components/Modal';
import { selectCurrentUserData } from '../../../features/authentication/authSlice';
import { useSelector } from 'react-redux';
import DropDown from '../../../components/DropDown';
import CustomToast from '../../../components/Toast';
import { useDashboardContext } from '../../dashboard/context';
import UserTypes from '../../../enums/userTypes';

const AdditionalOptions = () => {
  const [expand, setExpand] = React.useState(false);
  const user = useSelector(selectCurrentUserData);
  const [availableSchoolYears, setAvailableSchoolYears] = React.useState([]);
  const [isCopied, setIsCopied] = React.useState(false);
  const [getAvailableSchoolYears] = useGetAvailableSchoolYearsMutation();

  const [allStates, setAllStates] = React.useState([]);
  const [getAllStates] = useGetAllStatesMutation();
  const [getAllSchools] = useGetAllSchoolsMutation();
  const [generateOneTimeCode] = useGenerateOneTimeCodeMutation();
  const [updateSchoolYear] = useUpdateSchoolYearMutation();
  const [getschoolInfo] = useGetschoolInfoMutation();
  const [updateState] = useUpdateStateMutation();
  const [updateAdditonalOptionsComment] = useUpdateAdditonalOptionsCommentMutation();
  const [getCRMUrl] = useGetCRMUrlMutation();
  const [otpModal, setOtpModal] = React.useState(false);
  const [allSchools, setAllSchools] = React.useState([]);
  const [oneTimePassword, setOneTimePassword] = React.useState('');
  const [comment, setComment] = React.useState('');
  const [selectedShoolId, setSelectedSchoolId] = React.useState('');
  const getData = useDashboardContext();

  React.useEffect(() => {
    if (expand) {
      getAvailableSchoolYearsAsync();
      getAllStatesAsync();
      getAllSchoolsAsync();
    }
  }, [expand]);

  async function getAvailableSchoolYearsAsync() {
    try {
      const availableSchoolYearsResponse = await getAvailableSchoolYears().unwrap();
      setAvailableSchoolYears(() => availableSchoolYearsResponse);
    } catch (error) {
      console.log(error);
    }
  }

  async function generateOneTimeCodeAsync() {
    try {
      const generateOneTimeCodeResponse = await generateOneTimeCode().unwrap();
      const data = JSON.parse(generateOneTimeCodeResponse);
      console.log(data);
      setOtpModal(true);
    } catch (error) {
      console.log('Error parsing response:', error.data);
      if (error.data) {
        setOtpModal(true);
        setOneTimePassword(error.data);
      }
    }
  }

  async function updateSchoolYearAsync(event) {
    const year = event.target.value;

    try {
      const updateSchoolYearResponse = await updateSchoolYear(parseInt(year)).unwrap();
      console.log(updateSchoolYearResponse);
    } catch (error) {
      console.log(error);
    }
  }

  async function getAllStatesAsync() {
    try {
      const allStatesResponse = await getAllStates().unwrap();
      setAllStates(() => allStatesResponse);
    } catch (error) {
      console.log(error);
    }
  }

  async function getAllSchoolsAsync() {
    try {
      const allSchoolsResponse = await getAllSchools().unwrap();
      setAllSchools(() => allSchoolsResponse);
      setSelectedSchoolId(allSchoolsResponse[0].id);
    } catch (error) {
      console.log(error);
    }
  }

  async function updateAdditonalOptionsCommentAsync() {
    try {
      const options = {
        schoolId: selectedShoolId,
        comment: comment
      };
      const updateAdditonalOptionsCommentResponse = await updateAdditonalOptionsComment(
        options
      ).unwrap();
      console.log(updateAdditonalOptionsCommentResponse);
    } catch (error) {
      console.log(error);
    }
  }

  async function updateStateAsync(e) {
    const stateId = e.target.value;
    try {
      await updateState(stateId).unwrap();
    } catch (error) {
      console.log(error);
    }
  }

  const otpHandler = () => {
    generateOneTimeCodeAsync();
  };

  const crmHandler = async() => {
    try{
      const response = await getCRMUrl().unwrap();
      const newTab = window.open(response.data, '_blank');
      newTab.focus();
    }
    catch(error){
      CustomToast('Open CRM Failed!', 'error');
      console.log('CRM Failed!');
    }
  };

  async function handleSelectSchool(event) {
    const selectedSchoolId = event.target.value;
    setSelectedSchoolId(selectedSchoolId);
    try {
      const response = await getschoolInfo(selectedSchoolId).unwrap();
      setAvailableSchoolYears(response.schoolYears);
      setComment(response.comments);
      getData.setIsSchoolChange(new Date().getSeconds());
    } catch (error) {
      console.log(error);
    }
  }

  const modal = (
    <>
      <Modal
        titleName="1-time code"
        isOpen={otpModal}
        onClose={() => setOtpModal(false)}
        contentWidth="400px">
        <label className="form-label">code</label>
        <input id="otp-input" defaultValue={oneTimePassword} className="form-control" type="text" />
        <div className="d-flex justify-content-center m-3">
          <button
            className="btn btn-castleRed"
            type="button"
            onClick={() => {
              const otpInput = document.getElementById('otp-input');
              navigator.clipboard.writeText(otpInput.value).then(() => {
                setIsCopied(true);
                setTimeout(() => setIsCopied(false), 3000);
              });
            }}>
            Copy
          </button>
        </div>
        {isCopied && (
          <span className="d-flex justify-content-center" style={{ color: 'green' }}>
            Copied!
          </span>
        )}
      </Modal>
    </>
  );

  const SchoolYear = (
    <>
      <label className="form-label me-1">School Year</label>
      <OverlayTrigger
        key="schoolYear"
        placement="top"
        overlay={
          <Tooltip className="custom-tooltip">
              You can select a prior school year to view data from that year. While viewing prior years&apos; data you cannot modify assignments, classes or student accounts. However, you will be able to score assignments. Additionally, if available, you can select the next school year. When the next school year is selected you can create accounts and setup classes and assignments. Students will not be able to login to these new accounts until the next school year starts.
          </Tooltip>
        }>
        <FontAwesomeIcon className="modal-title-icon clr-fa-circle-question" icon={faQuestionCircle} />
      </OverlayTrigger>
      <select onChange={(event) => updateSchoolYearAsync(event)} className="form-select">
        {availableSchoolYears.map((item, index) => (
          <option key={index} selected={item.selected}>
            {item.name}
          </option>
        ))}
      </select>
    </>
  );
  
  const State = (
    <>
      <label className="form-label">State</label>
      <select onChange={(event) => updateStateAsync(event)} className="form-select">
        {allStates.map((item, index)=>(
          <option key={index} value={item.id} selected={item.selected}>
            {item.name}
          </option>
        ))}
      </select>
    </>
  );

  const inputFields = expand && (
    <Row className="mt-3">
      {false && (
        <>
          <div className="col-sm-6">
            <DropDown
              onChangeHandler={(e) => updateStateAsync(e)}
              label="State"
              value={allStates}
            />
          </div>
          <div className="col-sm-6">
            <label className="form-label" style={{paddingRight:'5px'}}>School Year</label>
            <OverlayTrigger
              key="schoolYear"
              placement="top"
              overlay={
                <Tooltip className="custom-tooltip">You can select a prior school year to view data from that year. While viewing prior years&apos; data you cannot modify assignments, classes or student accounts. However, you will be able to score assignments. Additionally, if available, you can select the next school year. When the next school year is selected you can create accounts and setup classes and assignments. Students will not be able to login to these new accounts until the next school year starts.</Tooltip>
              }>
              <FontAwesomeIcon className="modal-title-icon" icon={faQuestionCircle} style={{color: '#88cbf1'}}/>
            </OverlayTrigger>
            <select onChange={(event) => updateSchoolYearAsync(event)} className="form-select">
              {availableSchoolYears.map((item, index) => (
                <option key={index} selected>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-sm-6 mt-4">
            <DropDown
              label="School"
              value={allSchools}
              onChangeHandler={(e) => handleSelectSchool(e)}
            />
          </div>
          <div className="col-sm-6 mt-4 d-flex flex-column">
            <label className="form-label">1-time code</label>
            <button onClick={otpHandler} className="btn btn-castleOrange">
              Generate
            </button>
          </div>

          <div className="col-sm-6 mt-4 d-flex flex-column">
            <label className="form-label">CRM</label>
            <button onClick={crmHandler} className="btn btn-castleOrange">
              Open CRM
            </button>
          </div>

          <div className="col-sm-12 mt-4">
            <label className="form-label">Comment</label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Comment"
              className="form-control"
              type="text"
            />
          </div>
          <div className="col-sm-12 d-flex justify-content-end">
            <button onClick={updateAdditonalOptionsCommentAsync} className="btn btn-castleRed mt-3">
              Save
            </button>
          </div>
        </>
      )}
      {[UserTypes.Teacher, UserTypes.Reviewer, UserTypes.Guest, UserTypes.HomeTeacher].includes(user.UserType) && (
        <div className="col-sm-12 pb-2">
          {SchoolYear}
        </div>
      )}
      {[UserTypes.SuperAdministrator, UserTypes.Administrator, UserTypes.Trainer, UserTypes.SuperSales, UserTypes.Sales].includes(user.UserType) && (
        <>
          <div className="col-sm-6 pb-2">
            {State}
          </div>
          <div className="col-sm-6 pb-2">
            {SchoolYear}
          </div>
        </>
      )}
    </Row>
  );
  return (
    <div className="additional-tab mb-3 ">
      <h4
        onClick={() => setExpand(!expand)}
        className="d-flex align-items-center justify-content-between">
        Additional Options{' '}
        <span style={{ transform: `${expand ? 'rotate(90deg)' : 'rotate(0deg)'}` }}>
          <FontAwesomeIcon size="2xl" icon={faChevronRight} />
        </span>
      </h4>
      {inputFields}
      {modal}
    </div>
  );
};

export default AdditionalOptions;
